export default "__VITE_ASSET__DjCNJe0D__"